export const navigation = [
  { id: 'cockpit', label: 'Cockpit', icon: 'grid' },
  { id: 'approvals', label: 'Approvals', icon: 'checkSquare', count: 7 },
  { id: 'agents', label: 'Agents', icon: 'cpu' },
  { id: 'scheduler', label: 'Scheduler', icon: 'calendar' },
  { id: 'brain', label: 'Brain', icon: 'share2' },
  { id: 'channels', label: 'Channels', icon: 'radio' },
  { id: 'console', label: 'Console', icon: 'terminal' }
];

export const agents = [
  { id: 1, name: 'Atlas', role: 'Orchestrator', status: 'running', progress: 84, tasks: 26, icon: 'command' },
  { id: 2, name: 'Scout', role: 'Research', status: 'running', progress: 67, tasks: 18, icon: 'search' },
  { id: 3, name: 'Quill', role: 'Content', status: 'queued', progress: 42, tasks: 12, icon: 'edit3' },
  { id: 4, name: 'Vector', role: 'Growth', status: 'running', progress: 91, tasks: 31, icon: 'trendingUp' },
  { id: 5, name: 'Ledger', role: 'Finance', status: 'autonomous', progress: 76, tasks: 15, icon: 'dollarSign' },
  { id: 6, name: 'Sentinel', role: 'Compliance', status: 'failed', progress: 28, tasks: 9, icon: 'shield' },
  { id: 7, name: 'Relay', role: 'Support', status: 'running', progress: 58, tasks: 22, icon: 'headphones' },
  { id: 8, name: 'Forge', role: 'Engineering', status: 'autonomous', progress: 88, tasks: 19, icon: 'gitBranch' },
  { id: 9, name: 'Prism', role: 'Data Pipeline', status: 'idle', progress: 34, tasks: 6, icon: 'database' },
  { id: 10, name: 'Warden', role: 'QA & Testing', status: 'queued', progress: 46, tasks: 11, icon: 'checkCircle' }
];

export const initialApprovals = [
  {
    id: 'APR-2841',
    agent: 'Vector',
    title: 'Launch Q4 retargeting campaign',
    description: 'Activate 3 ad sets across Meta with a total daily cap of $1,200.',
    risk: 'high',
    time: '2m ago',
    impact: '$36K max spend',
    icon: 'trendingUp'
  },
  {
    id: 'APR-2840',
    agent: 'Quill',
    title: 'Publish customer story',
    description: 'Push the approved Helios case study to the website and LinkedIn.',
    risk: 'low',
    time: '6m ago',
    impact: 'Public content',
    icon: 'edit3'
  },
  {
    id: 'APR-2839',
    agent: 'Ledger',
    title: 'Issue service credit',
    description: 'Apply a $2,400 service credit to Acme Corporation’s next invoice.',
    risk: 'medium',
    time: '11m ago',
    impact: '$2.4K credit',
    icon: 'dollarSign'
  }
];

export const events = [
  { agent: 'Scout', text: 'Completed competitor intelligence brief', time: 'just now', status: 'success' },
  { agent: 'Atlas', text: 'Delegated campaign analysis to Vector', time: '1m', status: 'active' },
  { agent: 'Sentinel', text: 'Compliance scan requires intervention', time: '4m', status: 'error' },
  { agent: 'Quill', text: 'Drafted 4 channel variants', time: '8m', status: 'success' }
];